import { Loader2 } from "lucide-react";

import HefringLogo from "assets/hefring-wordmark.svg";
import { Card, CardContent, CardHeader } from "components/ui/card";
import { Color } from "utils/theme";

export default function ConnectionErrorScreen() {
  return (
    <section className="h-screen w-full flex flex-col justify-between items-center text-center py-6 px-6 overflow-auto">
      <img
        className="h-12"
        src={HefringLogo}
        alt="Hefring Logo"
        height={"100%"}
        width={"100%"}
      />
      <Card className="mt-4 min-w-[400px] items-center p-4">
        <CardHeader>
          <p className="text-center font-medium text-2xl">No connection</p>
          <p
            className="text-center text-base"
            style={{ color: Color.Primary[400] }}
          >
            No connection to IMAS hardware
          </p>
        </CardHeader>
        <CardContent className="flex items-center space-x-3 lg:p-0 p-0 pb-4 lg:pb-4">
          <Loader2 className="animate-spin" />
          <p className="text-center text-lg">Reconnecting</p>
        </CardContent>
      </Card>
      <p style={{ color: Color.Primary[500] }} className="mt-1">
        Trouble connecting? Contact support@hefringmarine.com
      </p>
    </section>
  );
}
